module.exports = __webpack_public_path__ + "img/sedi-operative-emt.f677c922.png";